export const GEOCODING_API_KEY = 'AIzaSyAdrNf-IrKdYuQEx8oMJBce37Hei0LC9ys'

export const MAPBOX_API_KEY =
  process.env.NODE_ENV === 'production'
    ? 'pk.eyJ1IjoiYmlnZmlzaC1odXRjaGllcy10b29sYm94IiwiYSI6ImNsNzRmY2EyZTFnZXozbnJ4M3huanpoMm0ifQ.M_c0hSa99c87_kyBgr6GGA'
    : 'pk.eyJ1IjoiYmlnZmlzaC1odXRjaGllcy10b29sYm94IiwiYSI6ImNsMWxuY3htcjA3aGIza24ycjR1cnoxZTAifQ.WXNstz2DaZYq0JM6iehPZw'
